"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _Icon = _interopRequireDefault(require("./_internal/Icon"));
var WarningOutlined = /*#__PURE__*/_react["default"].forwardRef(function (ddProps, ref) {
  var props = {};
  var svg = /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    className: "dt__icon",
    viewBox: "0 0 1024 1024",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true"
  }, props), /*#__PURE__*/_react["default"].createElement("defs", null), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M512 64c247.424 0 448 200.576 448 448S759.424 960 512 960 64 759.424 64 512 264.576 64 512 64zm0 81.45c-202.453 0-366.55 164.118-366.55 366.55 0 202.453 164.118 366.55 366.55 366.55 202.453 0 366.55-164.118 366.55-366.55 0-202.453-164.118-366.55-366.55-366.55zM512 640a42.667 42.667 0 110 85.333A42.667 42.667 0 01512 640zm6.677-341.333a42.667 42.667 0 0142.518 46.464l-20.16 225.642a29.163 29.163 0 01-58.07 0l-20.16-225.642a42.667 42.667 0 0138.72-46.294l1.899-.128 15.253-.042z"
  }));
  return /*#__PURE__*/_react["default"].createElement(_Icon["default"], (0, _extends2["default"])({}, ddProps, {
    svg: svg,
    ref: ref
  }));
});
WarningOutlined.displayName = "WarningOutlined";
var _default = exports["default"] = WarningOutlined;